import { Container } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeList, init, update } from "../../redux/actions/evaluationCategory";
import Footer from "../common/Footer";
import Header from "../common/Header";

export default function UpdateValuationCategoryMaster() {
  const [rows, setRows] = useState([]);
  const [age, setAge] = useState("");

  const dispatch = useDispatch();
  const [abolitionFlgLabelFalse, abolitionFlgLabelTrue] = useSelector(
    state => state.evaluationCategory.abolitionFlgText
  );
  const abolitionFlgValueTrue = useSelector(state => state.evaluationCategory.abolitionFlgValue[1]);
  const categories = useSelector(state => state.evaluationCategory.categories);
  const selectList = useSelector(state => state.evaluationCategory.list);
  const abolitionFlgValue = useSelector(state => state.evaluationCategory.abolitionFlgValue);
  const selectAge = useSelector(state => state.evaluationCategory.age);
  const row = useSelector(state => state.evaluationCategory.rows);

  useEffect(
    () => {
      setAge(selectAge);
    },
    [selectAge]
  );
  useEffect(
    () => {
      setRows(row);
    },
    [row]
  );

  //初期処理
  useEffect(
    () => {
      dispatch(init());
    },
    [dispatch]
  );
  const handleChange = event => {
    const selectedListId = event.target.value;
    dispatch(
      changeList({
        categories: categories,
        listId: selectedListId,
        abolitionFlgValue: abolitionFlgValue
      })
    );
  };

  const handleGridDataChange = params => {
    const { id, field, value } = params;

    setRows(prevData => {
      const newData = prevData.map(row => {
        if (row.id === id) {
          return { ...row, [field]: value };
        }
        return row;
      });
      return newData;
    });
  };

  const updateSubmit = () => {
    dispatch(update(rows));
  };
  const columns = [
    { field: "categoryId", headerName: "カテゴリID", width: 140, editable: true, headerClassName: "headerColor", flex: 1 },
    { field: "categoryName", headerName: "カテゴリ名", editable: true, width: 157, headerClassName: "headerColor", flex: 1 },
    {
      field: "abolition",
      headerName: "廃止",
      type: "singleSelect",
      valueOptions: [{ value: abolitionFlgValueTrue, label: abolitionFlgLabelTrue }],
      renderCell: params =>
        <div>
          {params.value === abolitionFlgValueTrue ? abolitionFlgLabelTrue : abolitionFlgLabelFalse}
        </div>,
      editable: true,
      width: 150,
      headerClassName: "headerColor",
      flex: 1
    },
    {
      field: "registeredDate",
      headerName: "登録日時",
      type: "dateTime",
      editable: false,
      width: 180,
      headerClassName: "headerColor",
      renderCell: params =>
        <div>
          {params.value
            ? new Date(params.value).toLocaleString("ja-JP", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit"
              })
            : ""}
        </div>,
      flex: 1
    },
    {
      field: "updatedDate",
      headerName: "更新日時",
      type: "dateTime",
      editable: false,
      width: 180,
      headerClassName: "headerColor",
      renderCell: params =>
        <div>
          {params.value
            ? new Date(params.value).toLocaleString("ja-JP", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit"
              })
            : ""}
        </div>,
      flex: 1
    }
  ];
  return (
    <Box>
      <Header />
      <Container>
        <Box
          sx={{
            marginTop: 4,
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 2
          }}
        >
          <Typography component="h3" variant="h7" align="left">
            評価カテゴリマスタ更新
          </Typography>
        </Box>
        <Box
          sx={{
            m: 1,
            display: "flex",
            flexDirection: "column",
            paddingLeft: 2
          }}
        >
          <Typography component="h4" variant="h7" align="left">
            更新したい評価リストを選択してください
          </Typography>
        </Box>
        <Box
          sx={{
            margin: 2,
            display: "flex",
            flexDirection: "column",
            bgcolor: "#fff9c4"
          }}
        >
          <FormControl size="small" sx={{ minWidth: 180, bgcolor: "white", marginRight: "auto", mt: 2, ml: 8 }}>
            <InputLabel id="demo-simple-select-label">評価内容</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={age}
              label="評価内容"
              onChange={handleChange}
            >
              {selectList.map(list =>
                <MenuItem value={list.value} key={list.value}>
                  {list.text}
                </MenuItem>
              )}
            </Select>
          </FormControl>

          <Box sx={{ alignItems: "center", justifyContent: "center", m: 2 }}>
            <Container maxWidth="md">
              <div
                style={{
                  height: 330,
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <DataGrid
                  sx={{
                    bgcolor: "white",
                    "& .headerColor": {
                      backgroundColor: "#ffcc80"
                    }
                  }}
                  rows={rows}
                  columns={columns}
                  hideFooter={true}
                  onCellEditCommit={handleGridDataChange}
                />
              </div>
            </Container>
          </Box>
        </Box>
        <Container maxWidth="sm">
          <Stack sx={{}} direction="row" spacing={5} justifyContent="center">
            <Button variant="contained" onClick={updateSubmit} sx={{ bgcolor: "#82b1ff", width: "50%" }}>
              更新
            </Button>
          </Stack>
        </Container>

        <Box sx={{ alignItems: "right", justifyContent: "right", m: 2, display: "flex" }}>
          <Button variant="contained" size="medium" href="/AdminMenu" sx={{ bgcolor: "#82b1ff", marginLeft: "auto" }}>
            戻る
          </Button>
        </Box>
      </Container>
      <Footer />
    </Box>
  );
}
